(() => {
  const guide = document.querySelector('.buying-guide');
  if (!guide) return;
  guide.querySelectorAll('[data-layout]').forEach(button => button.addEventListener('click', () => {
    guide.querySelectorAll('[data-layout]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    guide.querySelectorAll('[data-plan]').forEach(plan => { plan.style.display = plan.dataset.plan === button.dataset.layout ? '' : 'none'; });
    document.querySelector('#bg-plan-title').textContent = `Illustrative ${button.dataset.layout} arrangement with a clear route around the furniture`;
  }));
})();
